export default function joinedClassName(...names)
{
  return names.filter(x => x !== undefined).join(' ')
}
